import data from '../../assets/json/products.json';
import { API_TIMEOUT } from '../../config/app';
import { catalog, objectId } from './catalog';
import { LoremIpsum } from 'lorem-ipsum';
import { Category } from './categories';

const lorem = new LoremIpsum({
    sentencesPerParagraph: {
        max: 8,
        min: 4
    },
    wordsPerSentence: {
        max: 16,
        min: 4
    }
});

const findCategory = (name) => {
    return Category.all().find((c) => c.name.toLowerCase() == name.toLowerCase());
};

const seed = data.reduce((list, item) => {
    const products = item.products.map((product) => ({
        id: objectId(),
        ...product,
        description: lorem.generateSentences(4),
        categories: [findCategory(item.category)]
    }));
    return list.concat(products);
}, []);

export const Product = catalog('products', seed);

export const list = ({ filter = '', category: categoryFilter = '', page = 1, size = 10 }) => {
    filter = filter.toLowerCase();
    categoryFilter = categoryFilter.toLowerCase();
    return new Promise((resolve) => {
        const products = Product.all();
        const query = products
            .filter(
                (product) =>
                    categoryFilter == '' ||
                    product.categories.some((category) =>
                        category.name.toLowerCase().includes(categoryFilter)
                    )
            )
            .filter((product) => product.name.toLowerCase().includes(filter));
        const start = (page - 1) * size;
        const end = start + size;
        const total = query.length;
        const records = query.slice(start, end);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    page,
                    size,
                    total,
                    records
                }
            });
        }, API_TIMEOUT);
    });
};

export const get = (id) => {
    return new Promise((resolve) => {
        const product = Product.find((item) => item.id === id);
        setTimeout(() => {
            resolve({
                success: true,
                data: {
                    record: product
                }
            });
        }, API_TIMEOUT);
    });
};

export const create = (item) => {
    return new Promise((resolve) => {
        const categories = Category.all().filter((category) =>
            item.categories.includes(category.id)
        );
        const product = { id: objectId(), ...item, categories };
        Product.add(product);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Product created successfully.',
                data: {
                    record: product
                }
            });
        }, API_TIMEOUT);
    });
};

export const update = (item) => {
    return new Promise((resolve) => {
        const categories = Category.all().filter((category) =>
            item.categories.includes(category.id)
        );
        Product.update(item.id, { ...item, categories });
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Product updated successfully.'
            });
        }, API_TIMEOUT);
    });
};

export const remove = (id) => {
    return new Promise((resolve) => {
        Product.remove(id);
        setTimeout(() => {
            resolve({
                success: true,
                message: 'Product deleted successfully.'
            });
        }, API_TIMEOUT);
    });
};
